import { Component, inject } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToastService } from './Toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-toasters',
  standalone: true,
  imports: [ToastModule],
  templateUrl: './toasters.component.html',
  styleUrl: './toasters.component.scss',
  providers: [MessageService]
})
export class ToastersComponent {
  translate = inject(TranslateService);
  constructor(private toastService: ToastService, private messageService: MessageService) {
    // Subscribe to toast events from the service
    this.toastService.toastMessages$.subscribe(message => {
      let msg = {
        ...message,
        detail: this.translate.instant(message.detail),
        summary: this.translate.instant(message.summary),
      };
      this.messageService.add(msg);
    });
  }

}
